import { useState } from "react";
import Modal from "../../../../../global/Modal/Modal";
import SelectAddressStep from "./SelectAddressStep";

interface SelectAddressFormProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}

const SelectAddressForm = ({ open, setOpen }: SelectAddressFormProps) => {
  const [AddressStep, setAddressStep] = useState(2);

  const handleCloseModal = () => {
    setAddressStep(2);
    setOpen(false);
  };

  return (
    <Modal visible={open} setVisible={() => {}} title="آدرس برگشت" handleClose={handleCloseModal}>
      <SelectAddressStep AddressStep={AddressStep} setAddressStep={setAddressStep} setOuterOpen={setOpen} />
    </Modal>
  );
};

export default SelectAddressForm;
